/// <reference path="../../typings/tsd.d.ts" /> 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ClaimDefinitionService = /** @class */ (function (_super) {
            __extends(ClaimDefinitionService, _super);
            function ClaimDefinitionService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            ClaimDefinitionService.prototype.getAllProcessClaimsExecutionSide = function (processTypeId) {
                var parameters = {
                    processTypeId: processTypeId
                };
                var query = this.breezeModule.EntityQuery
                    .from("ClaimDefinitionsCustom")
                    .withParameters(parameters);
                return this.executeQuery(query);
            };
            ClaimDefinitionService.prototype.getAllProcessClaims = function (processConfigurationId) {
                var query = this.breezeModule.EntityQuery
                    .from("ClaimDefinitions")
                    .where('processConfiguration_id', '==', processConfigurationId)
                    .expand("myOnAssignProcessAction, myOnUnAssignProcessAction")
                    .orderBy("type");
                return this.executeQuery(query);
            };
            ClaimDefinitionService.prototype.getAllProcessAndSystemClaims = function (processConfigurationId) {
                var pred = this.breezeModule.Predicate
                    .create('processConfiguration_id', '==', processConfigurationId)
                    .or('processConfiguration_id', '==', null);
                var query = this.breezeModule.EntityQuery
                    .from("ClaimDefinitions")
                    .where(pred)
                    .orderBy("type");
                return this.executeQuery(query);
            };
            ClaimDefinitionService.prototype.getApiProcessClaims = function (processConfigurationId) {
                var d = this.$q.defer();
                this.$http.get('./api/claims/' + processConfigurationId).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ClaimDefinitionService.prototype.getUserRepositoryComponents = function () {
                var d = this.$q.defer();
                this.$http.get('./api/ExtensibleComponent/GetExternalUserRepositories').then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ClaimDefinitionService.prototype.getById = function (id) {
                return this.fetchById(id, "ClaimDefinition");
            };
            return ClaimDefinitionService;
        }(warsApp.services.DataService));
        services.ClaimDefinitionService = ClaimDefinitionService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ClaimDefinitionService', ['breeze', '$q', '$http']);
